
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    TOURNAMENTLIST_ACTION,
    ALL_TOURNAMENTLIST,
    ADD_TOURNAMENTLIST,
    FETCH_TOURNAMENTLIST,
    EDIT_TOURNAMENTLIST,
    DELETE_TOURNAMENTLIST
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * Tournament List Actions
 */

    export const allTournamentList = () =>{    
    
        return (dispatch) => { 
            dispatch({ type: TOURNAMENTLIST_ACTION });
            return axios.get(AppConfig.apiurl+'/api/gettournamentlist', { headers: AuthHeader.header })         
            .then(response => {             
                const alldata=response.data.data;
                dispatch({ type: ALL_TOURNAMENTLIST, payload: alldata });
            });
        }        
    
    }

    export const addTournamentList = (data) =>{
    
        var payload={
            "tournament":data.target.name.value,
            "sgdate":data.target.seldate.value,
            "course":data.target.course.value,
            "country":data.target.country.value,
        }
        return (dispatch) => { 
            dispatch({ type:TOURNAMENTLIST_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addtournamentlist', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    allTournamentList()(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_TOURNAMENTLIST});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const fetchTournamentList = (id) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:TOURNAMENTLIST_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/gettournamentdetails', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_TOURNAMENTLIST, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const editTournamentList = (data, id) =>{
    
        var payload={
            "id":id,
            "tournament":data.target.name.value,
            "sgdate":data.target.seldate.value,
            "course":data.target.course.value,
            "country":data.target.country.value,
        }
       
        return (dispatch) => { 
            dispatch({ type:TOURNAMENTLIST_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/edittournamentlist', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    allTournamentList()(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: EDIT_TOURNAMENTLIST});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }


    export const deleteTournamentList = (id) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:TOURNAMENTLIST_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deletetournamentlist', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    allTournamentList()(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_TOURNAMENTLIST});                    
                }
                
                
            });
        
        }
    }


   

